import { render, staticRenderFns } from "./EditLostAndFound.vue?vue&type=template&id=66f3c2e0&scoped=true"
import script from "./EditLostAndFound.vue?vue&type=script&lang=js"
export * from "./EditLostAndFound.vue?vue&type=script&lang=js"
import style0 from "./EditLostAndFound.vue?vue&type=style&index=0&id=66f3c2e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f3c2e0",
  null
  
)

export default component.exports